import React from 'react';

import { 
	func, 
	string, 
} from 'prop-types';

export default class TextInputEventHandler extends React.Component {
    static propTypes = {
    	value : string,
    	render : func.isRequired,
    	onEnter : func,
    	onBlur : func,
    }
	
    constructor(props){
    	super(props);
    	const {value} = props;
    	this.state = {
    		value : value || '',
    	};
    }
	
	onChange = (event) => {
		this.setState({
			value:event.target.value,
		});
	};

	onKeyPress = (e) =>{
		const {value, onEnter} = this.props;
		if(value!==this.state.value){
			if(e.key.toLowerCase()==='enter'){
				if(onEnter){
					onEnter(this.state.value,e);
					e.preventDefault(); // for disable onChange event.
				}
			}
		}
	};
	onBlur = (e)=>{
		const {value, onBlur} = this.props;
		if(value!==this.state.value){
			onBlur&&onBlur(this.state.value,e);
		}
	};

	render(){
		const {value,onChange,onKeyPress,onBlur,render,...other} = this.props;
    	return render({
    		value : this.state.value,
    		onChange : this.onChange,
    		onKeyPress : this.onKeyPress,
    		onBlur : this.onBlur
    	},other);
	}
}